var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "8 8 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bank 1 logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.3333C21.4058 16.3333 18.4384 17.5624 16.2505 19.7503C14.0625 21.9383 12.8334 24.9057 12.8334 27.9999C12.8334 31.0941 14.0625 34.0616 16.2505 36.2495C18.4384 38.4374 21.4058 39.6666 24.5 39.6666C27.5942 39.6666 30.5617 38.4374 32.7496 36.2495C34.9375 34.0616 36.1667 31.0941 36.1667 27.9999C36.1667 24.9057 34.9375 21.9383 32.7496 19.7503C30.5617 17.5624 27.5942 16.3333 24.5 16.3333Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5001 39.6667C38.2668 39.6667 38.0335 39.55 37.8001 39.4333C37.3335 39.0833 37.2168 38.2667 37.5668 37.8C39.6668 34.8833 40.8335 31.5 40.8335 28C40.8335 24.5 39.6668 21.1167 37.5668 18.2C37.2168 17.7333 37.3335 16.9167 37.8001 16.5667C38.2668 16.2167 39.0835 16.3333 39.4335 16.8C41.8835 20.0667 43.1668 23.9167 43.1668 28C43.1668 32.0833 41.8835 35.9333 39.4335 39.2C39.2001 39.55 38.8501 39.6667 38.5001 39.6667Z",
    fill: "#0F62FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank1);
export default __webpack_public_path__ + "static/media/bank1.c3fc738e5bf530cd9bb9fd062d0ab845.svg";
export { ForwardRef as ReactComponent };